"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ButtonWidgetStyles_1 = require("../../styles/ButtonWidgetStyles");
exports.ButtonType = ButtonWidgetStyles_1.ButtonType;
var Declarative_1 = require("../../utils/Declarative");
var ButtonBase_1 = require("./ButtonBase");
var DynamicThemeComponent_1 = require("../DynamicThemeComponent");
var ButtonWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonWidget, _super);
    function ButtonWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { active: false, focus: false, hover: false };
        _this.handleActive = function (active) { return _this.setState({ active: active }); };
        _this.handleFocus = function (focus) { return _this.setState({ focus: focus }); };
        _this.handleHover = function (hover) { return _this.setState({ hover: hover }); };
        return _this;
    }
    ButtonWidget.getDerivedStateFromProps = function (props) {
        if (props.disabled) {
            return { active: false, focus: false, hover: false };
        }
        return null;
    };
    ButtonWidget.prototype.render = function () {
        var _a = this.props, buttonType = _a.buttonType, children = _a.children, getContent = _a.getContent, style = _a.style, testId = _a.testId, buttonBaseProps = tslib_1.__rest(_a, ["buttonType", "children", "getContent", "style", "testId"]);
        var buttonStyle = ButtonWidgetStyles_1.getButtonStyle(buttonType);
        return (React.createElement(ButtonBase_1.ButtonBase, tslib_1.__assign({}, buttonBaseProps, { interactiveStyle: buttonStyle.interactive, onActive: this.handleActive, onFocus: this.handleFocus, onHover: this.handleHover, style: tslib_1.__assign(tslib_1.__assign({}, buttonStyle.base), style), testId: Declarative_1.testId(testId, 'Button') }), getContent ? getContent(tslib_1.__assign(tslib_1.__assign({}, this.state), { selected: this.props.selected, disabled: this.props.disabled })) : children));
    };
    ButtonWidget.defaultProps = { density: 'low' };
    return ButtonWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.ButtonWidget = ButtonWidget;
//# sourceMappingURL=ButtonWidget.js.map